export function formatINR(value) {
  if (value == null || isNaN(value)) return "—";
  return "₹" + Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: Number.isInteger(Number(value)) ? 0 : 2, maximumFractionDigits: 2,
  });
}

export function tierRate(product, qty) {
  let best = product.rate;
  (product.tier_prices || [])
    .slice()
    .sort((a, b) => a.min_qty - b.min_qty)
    .forEach((t) => {
      if (qty >= t.min_qty) best = t.rate;
    });
  return best;
}
